import Range from './range';
import Fee from './fee';
import Main from './main.vue';

Main.Fee = Fee;
Main.Range = Range;

export default Main;
